//libs
import { useContext } from 'react';

//components
import FederalNetworkSearch from './federal-network-search';
import { StoresContext } from '../../../../App';

//types
import { IFederalNetworkSearch } from '../types/ISearch';

const federalNetworkCompanies: IFederalNetworkSearch[] = [
    {
        name: 'ДИСТРИБЬЮТОРЫ',
        type: 'search',
        features: [
            { id: 'etm', name: 'ЭТМ', value: ['этм', 'etm', 'ЭТМ'] },
            { id: 'rus-svet', name: 'Русский свет', value: ['русский свет', 'rus-svet'] },
        ]
    }
];

const FeatureFilter = () => {
    const { setFeatureSearch } = useContext(StoresContext);

    return (
        <div className="feature-filter-block destributors-filter-block">
            <div className="feature-filter-block__title destributors-filter-block__title">ОФИСЫ ПРОДАЖ ДИСТРИБЬЮТЕРОВ</div>
            <FederalNetworkSearch 
                features={federalNetworkCompanies[0].features}
                setSearch={setFeatureSearch}
            />
        </div>
    );
};


export default FeatureFilter;